import React from "react";
import styles from "../Checklist.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileImport} from "@fortawesome/free-solid-svg-icons";
import {ChecklistItemModel} from "../../../../../models/checklist-model";
import FirebaseUsage from "../../../../../firebase/firebase.usage";
import {v4 as uuidv4} from "uuid";
import {COLLECTIONS} from "../../../../../firebase/constants";
import ProjectFileModel from "../../../../../models/responses/project-file.model";
import {useActiveProjectSelector} from "../../../../../store/selectors/project.selectors";
import {useUserSelector} from "../../../../../store/selectors/authorization.selectors";
import ChecklistUtils from "../../../../../utils/checklist/checklist.utils";
import {Button, Icon, Label, Modal} from "semantic-ui-react";


export default function ChecklistAttachmentInput(props: {
    checklistItem: ChecklistItemModel,
    completionRecord: any,
    deployment: string,
}) {
    const {checklistItem, completionRecord, deployment} = props;
    const inputFile = React.useRef<HTMLInputElement>(null);
    const activeProject = useActiveProjectSelector();
    const user = useUserSelector();
    const [showDeleteModal, setShowDeleteModal] = React.useState<any>(false);
    const [deleting, setDeleting] = React.useState(false);

    async function handleFiles(event) {
        event.preventDefault()
        const storageId = await FirebaseUsage.getDoc(COLLECTIONS.PROJECT_STORAGE, activeProject!.storageId)
            .then((doc) => doc.data()!.storageBucketId)
        const files = event.target.files
        let attachments: any[] = []
        for (const file of files) {
            let attachment: any = {}
            const reader = new FileReader()
            reader.onloadend = (e) => {
                attachment.fileName = file.name
                attachment.arrayBuffer = reader.result
                attachment.modified = file.lastModified
                attachment.type = file.type
                uploadFile(attachment, storageId)
            }
            reader.readAsArrayBuffer(file)
        }
        return attachments

    }

    const uploadFile = async (attachment: any, storageId: string)=> {
        const fileId = uuidv4();
        FirebaseUsage.uploadFileToStorage(`${storageId}/project_files/${fileId}`, attachment.arrayBuffer).catch((e) => console.log("Error: ", e));
        const projectFileRef = FirebaseUsage.getBlankDoc(COLLECTIONS.PROJECT_FILES);
        const uploadData: ProjectFileModel = {
            fileId: projectFileRef.id,
            modified: FirebaseUsage.timestamp(new Date(attachment.modified)),
            uploaded: FirebaseUsage.timestamp(),
            storagePath: `${storageId}/project_files/${fileId}`,
            fileName: attachment.fileName,
            projectId: activeProject!.projectId,
            userId: user!.userId!,
            type: attachment.type,
            taskId: checklistItem.taskId,
            checklistItemId: checklistItem.checklistItemId,
        }
        await ChecklistUtils.addChecklistAttachment(checklistItem.taskId, checklistItem.checklistItemId, projectFileRef.id, attachment.fileName)
        FirebaseUsage.setDocumentWithDoc(projectFileRef, uploadData).catch((e) => console.log("Error: ", e));
    }

    const downloadFile = async (storageId: string) => {
        const file = await FirebaseUsage.getCompoundQuery(COLLECTIONS.PROJECT_FILES,
        [['projectId', '==', activeProject!.projectId], ['fileId', '==', storageId]])
        const fileData = file.docs[0].data() as ProjectFileModel

        console.log(fileData)
        await FirebaseUsage.downloadFileFromStorage(fileData)
    }

    const generateAttachmentLabels = (attachments: any) =>
        attachments.map((attachment: any) => (
        <Label className={styles.AttachmentLabel} key={attachment.id} onClick={() => !deleting ? downloadFile(attachment.id) : undefined}>
            {attachment.name}
            <Icon
                name='delete'
                onMouseEnter={() => setDeleting(true)}
                onMouseLeave={() => setDeleting(false)}
                onClick={() => {
                    setShowDeleteModal({id: attachment.id, name: attachment.name})
                }}/>
        </Label>
    ))

    return completionRecord?.attachments ?(
        <div className={deployment === 'task' ? styles.AttachmentIconTask : styles.AttachmentIcon}>
            <input
                type="file"
                style={{"display": "none"}}
                ref={inputFile}
                multiple
                onChange={(e) => {
                    handleFiles(e)
                }}/>
            <FontAwesomeIcon icon={faFileImport} size='lg' onClick={() => inputFile.current?.click()}/>
            <div className={styles.AttachmentsContainer}>
                {generateAttachmentLabels(completionRecord.attachments)}
            </div>
            {showDeleteModal &&
                <Modal size={'mini'} open={true} closeIcon onClose={() => setShowDeleteModal(false)}>
                    <Modal.Content>
                        <h4>
                            Are you sure you want to delete {showDeleteModal.name}?
                        </h4>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            onClick={() => setShowDeleteModal(false)}
                        >No</Button>
                        <Button
                            negative
                            icon='trash alternate'
                            content='Yes'
                            labelPosition='right'
                            onClick={() =>
                                ChecklistUtils.removeChecklistAttachment(
                                    checklistItem.taskId,
                                    checklistItem.checklistItemId,
                                    showDeleteModal.id
                                ).then(() => setShowDeleteModal(false))}
                            />
                    </Modal.Actions>
                </Modal>}
        </div>
    ) : (
        <div className={deployment === 'task' ? styles.AttachmentIconTask : styles.AttachmentIcon}
             onClick={() => inputFile.current?.click()}
             >
            <input
                type="file"
                style={{"display": "none"}}
                ref={inputFile}
                multiple
                onChange={(e) => {
                    handleFiles(e)
                }}/>
            <FontAwesomeIcon icon={faFileImport} size='lg'/>
            Upload file
        </div>
    )
}